import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import home from '../../assets/home.png';
import oceans from '../../assets/oceans.png';
import land from '../../assets/land.png';
import air from '../../assets/air.png';
import near_space from '../../assets/near_space.png';
import take_action from '../../assets/take_action.png';
import logo from '../../assets/earthdna_logo.png';
import donate from '../../assets/donate.png';
import { bool, func } from 'prop-types';

const Spacer = styled.div`
  margin-top:8vh;
`;

const Spacer01 = styled.div`
  margin-top:5vh;
`;

const Earth = styled.h3`
  color:white;
  font-family: roboto;
  font-weight: 500;
  justify-content: left;
  font-size:1rem;
  margin:0px;
  display: inline-block;
  margin-left:0px;
`;

const Dna = styled.h3`
  color:#ed146f;
  font-family: roboto;
  font-weight: 500;
  justify-content: left;
  font-size:1rem;
  margin:0;
`;

const Htwo = styled.h3`
  text-decoration:none;
  margin-left: 0px;
  color:white;
  font-family: roboto;
  font-weight: 300;
  justify-content: center;
  font-size:0.7rem;
  margin-bottom:2px;
`;

const Contain= styled.div`
  display: flex;
  flex-direction:row;

`;

const Stack= styled.div`
  display: flex;
  flex-direction:column;
  justify-content:left;
  align-self:middle;

`;

const Nav = styled.div`
  height: 100%;
  background: rgba(0, 0, 0, 1);
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 70%;
  max-width: 300px;
  z-index: 200;
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform 0.3s ease-out;
  @media (min-width: 769px) {
    display:none;
  }
  
}
`;

const Btncontainer= styled.div`
  
  border: none;
  background-color: #000000; 
    border: none;
    color: white;
    vertical-align: middle;
    text-align: middle;
    
    font-family: roboto;
    font-weight: 400;
    text-decoration:none;
    padding-top: 15px;
    padding-bottom: 15px;
    flex-direction: row; 
    font-size: 1em;
    width:100%;
    display: flex;
    align-items: center;
    justify-content: left;

     &:hover {
    background-color: #780A38;
    opacity:100%;
    transition-duration: .5s;
  }
  Link{
  	text-decoration: none;
  }
`;

const Menuicon = styled.img`
  margin-left:40px;
  margin-right:15px;
  justify-content:center;
  align-self:center;
  width:20px;
  height:20px;

`;
const Logo = styled.img`
  margin-left:40px;
  margin-right:15px;
  justify-content:center;
  align-self:center;
  width:70px;
  height:70px;

`;


const Menu = ({ open, setOpen }) => {

  return (
    <Nav open={open}>
      <Spacer/>

      <Link to="/"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {home}/><div> HOME </div></Btncontainer>
      </Link>

      <Link to="/Oceans"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {oceans}/><div> OCEANS </div></Btncontainer>
      </Link>

      <Link to="/Land"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {land}/><div> LAND </div></Btncontainer>
      </Link>

      <Link to="/Atmosphere"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {air}/><div> ATMOSPHERE </div></Btncontainer>
      </Link>
      
      <Link to="/Near-Space"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {near_space}/><div> NEAR SPACE </div></Btncontainer>
      </Link>

      <Link to="/Take-Action"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {take_action}/><div> TAKE ACTION </div></Btncontainer>
      </Link>


      <Spacer01/>
      <a href= "https://earthdna.org/home/donate/"target="_blank"rel="noopener noreferrer"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      <Btncontainer><Menuicon src= {donate}/><div> DONATE </div></Btncontainer>
      </a>
      <Spacer01/>
      <Contain>
      <Logo src={logo}/>
      <a href= "https://earthdna.org/"target="_blank"rel="noopener noreferrer"style={{ textDecoration: 'none' }}onClick={() => setOpen(!open)}>
      
      <Stack>
      <Htwo>POWERED BY</Htwo>

      <Contain>
      <Earth>EARTH</Earth>
      <Dna>DNA</Dna>
      </Contain>
      </Stack>
      
      </a>
      </Contain>
    </Nav>
  )
}
Menu.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired,
}
export default Menu;